import axios, {parseResponseData} from '@/axiosInstance'
import {UserAvailabilitySchema} from '@/features/users-availability/types'
import {captureException} from '@sentry/react'
import {z} from 'zod'

// Get User Availability
export const HttpGetUserAvailabilityOptions = z.object({
    urlParams: z.object({
        userId: z.string()
    })
})

export type HttpGetUserAvailabilityOptions = z.infer<typeof HttpGetUserAvailabilityOptions>

export const httpGetUserAvailability = async ({urlParams: {userId}}: HttpGetUserAvailabilityOptions) => {
    const response = await axios.get(`/users/${userId}/availability`)
    return parseResponseData({
        responseData: response.data,
        responseShape: UserAvailabilitySchema,
        onZodError: captureException
    })
}

// Update User Availability
export const HttpUpdateUserAvailabilityOptions = z.object({
    urlParams: z.object({
        userId: z.string()
    }),
    data: z.object({}).passthrough()
})

export type HttpUpdateUserAvailabilityOptions = z.infer<typeof HttpUpdateUserAvailabilityOptions>

export const httpUpdateUserAvailability = async ({urlParams: {userId}, data}: HttpUpdateUserAvailabilityOptions) => {
    const response = await axios.patch(`/users/${userId}/availability`, data)
    return response
}
